import React from 'react';
import Icon from '@mdi/react';

const Icons = ({ path, size, color, style }) => {
  function detectSVGType(str) {
    const trimmed = str.trim();
    if (/^[MLCZHVQASTmlczhvqast\d\s.,-]+$/.test(trimmed)) return 'path-d';
    return 'plain-text';
  }

  if (detectSVGType(path) === 'plain-text') {
    return (
      <span
        style={{
          fontSize: `${size}rem`,
          ...style,
        }}
        className="material-symbols-outlined"
      >
        {path}
      </span>
    );
  }
  return (
    <Icon
      path={path}
      size={size || 1}
      color={color || 'var(--primary-color)'}
      style={style}
    />
  );
};

export default Icons;
